import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  mediaObject: {
    position: 'relative',
    display: 'flex',
    alignItems: 'flex-start',
  },
  mediaImageTop: {
    padding: "6px",
    display: "flex",
    alignItems: "center"
  },
  mediaImageCenter: {
    alignSelf: 'center',
  },
  mediaImageBottom: {
    marginBottom: 12,
    alignSelf: 'flex-end',
  },
  rootAvatar: {
    height: 60,
    width: 60,
  },
  mediaBody: {
    flex: '1 1 0%',
  },
  mediaHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: '12px'
  },
  mediaHeaderContent: {
    flex: 1,
  },
  mediaActions: {
    alignSelf: 'flex-start',
  },
  mediaFooter: {
    display: 'flex',
  },
}));
export default useStyles;
